var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,_vm._g({tag:"component",staticClass:"amx-button",class:_vm.classes,attrs:{"data-external":"amx-button","disabled":_vm.disabled,"to":_vm.href}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }